import { jsx as _jsx } from "react/jsx-runtime";
export default function VerticalText(props) {
    const { transform = '', label, ...otherProps } = props;
    return (_jsx("text", { ...otherProps, transform: `${transform}rotate(-90)`, textAnchor: "middle", children: label }));
}
//# sourceMappingURL=VerticalText.js.map